// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"kW-z","inlineTitle":"lW-z","sponsoredAdsWrapper":"mW-z","marketplaceRecosWrapper":"nW-z"};